// extracted by mini-css-extract-plugin
export var round = "Toggle-module--round--IMNxY";
export var slider = "Toggle-module--slider--AkIcV";
export var toggle = "Toggle-module--toggle--02NpU";